import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import ProductTemplate from './../Buypoint/Product/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Sellpoint',
    data () {
        return {
            user:{},
            market:{},
            sellpoint:{},
            categories:{},
            galleria:{},
            gallery:{},
            gallery_post:{},
            gallery_post_set_image:{},
            post:{},
            products: {},
            product: {},
            productMain:{},
            productItem:{},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn:false,
            edit_mode:false,
            loading: true,
            online: false,
            place_order: false,
            ordered_product: {},
            ordered_product_item:{},
            swipe_index: 0, // two way

            data_error_message: "",
            data_success_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name:"",
            payment_payer_email:"",
            payment_payer_phone:"",
            payment_service:"",
            
            addPanel:false,
            business_load_error_msg:"",
            newLookbookForm: false,
            newProductLookbookForm: false,
            max_plan_lookbooks:0,
            max_plan_lookbook_posts:0,
            total_lookbooks_added:0,
            can_add_more_lookbook:false,
            can_add_product_lookbook:false,
            addNewPost:false,
            file_info:{},
            refresh_button:false,
            disable_btn:false,
            action_loading:false,
            default_banner_image:"https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg",
            set_gallery_banner_image: '',

            gallery_view:false,
           
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                },
            },
            componentKey:0,
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'component-product': ProductTemplate,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        },

    },
    methods: {
        mobileSideNavToggle(action){
            if(action == "open"){
                var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

                if (isMobile) {
                    document.getElementById("mobileSideNav").style.width = "100%";
                }else{
                    document.getElementById("mobileSideNav").style.width = "50%";
                }
            }
            if(action == "close"){
                document.getElementById("mobileSideNav").style.width = "0";
                // or //document.getElementById("mobileSideNav").style.display = "none";
            }
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        checkIfVideo(url){
            if(url != undefined){
                let ext = url.split('.').pop();
                if(service.video_exts.includes(ext)){
                    return true;
                }else{
                    return false;
                }
            }
        },

        addComponent(attr1,attr2){
           
            this.addPanel = true;
                
            if(attr1 == "add-new-lookbook"){
                this.newLookbookForm = true;
            }
            if(attr1 == "add-new-product-lookbook"){
                this.newProductLookbookForm = true;
            }
            if(attr1 == "add-new-product-post"){
                //change this url to accomodate product
                this.$router.push("/"+this.$route.params.id+"/"+this.gallery.gallery_posts_group_url_name)
               // $('#quickviewModal').modal('hide');
                //then call
                this.newProductLookbookForm = true;
            }
            if(attr1 == "add-new-post"){
                this.addNewPost = true;
               // $('#quickviewModal').modal('hide');
                this.gallery = attr2;

            }
            
            //ifopen sidebar if closed and gallery_view is on turn off
            if(this.gallery_view){
                //turn off
                this.gallery_view = false;
                //open side bar
                // this.mobileSideNavToggle("open");
                let self = this;
                setTimeout(function(){ self.mobileSideNavToggle("open"); }, 150)
            }

            //make page to jump to specific location
            // document.getElementById("addPanelView").scrollIntoView(); //general addPanelView otherwise use specific names

            //BETTER - srolls to the very top
            var top = document.getElementById("addPanelView").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
            window.scrollTo(0, top); 
        },

        setComponent(attr1,attr2){
            if(attr1 == "close-gallery-view"){
                this.gallery_view = false;
            }
        },

      

        preset() {
            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;//loggedIn options
                            //set sellpoint and seller options
                           this.is_editing();
                        }, this);
                    }else {
                      //  console.log(response)
                     //// this.$router.push('/login/');
                      }
                }).catch((err) => {
                    if(err) {
                        // console.log(err)
                        //this.$router.push('/login/');
                    }
                })
            }else {
               //console.log("error 2")
              // this.$router.push('/login/');
            }
        },

      
        setGallery(){
            this.loading = true;
            service.getGallerySearch(this, service.business_app_name).then(response => {
                if(response.body.status == 200) {
                    this.gallery = response.body.data;

                    // this.preset();
                    this.loading = false;
                }
            }).catch((err) => {})
        },

        setSellpoint(){ 
            this.loading = true;
            service.getAppBusinessByUserName(this, service.business_app_name).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data; 
                    document.title = this.sellpoint.business_name + " | SP";
                  
                   //set the banner image 
                   if((this.sellpoint.business_banner_image == this.default_banner_image) || (this.sellpoint.business_banner_image == 'error')){
                       //assign gw general banner image
                       this.set_gallery_banner_image = service.general_banner_image; 
                   }else{
                       //use the sellpoints banner image
                       this.set_gallery_banner_image = this.sellpoint.business_banner_image;
                   }
                    
                    //dummy settings
                    if(this.sellpoint.business_market_subscription_name == 'Free Plan'){
                        this.max_plan_lookbooks = 2;
                        this.max_plan_lookbook_posts = 5;
                    }
                    if(this.sellpoint.business_market_subscription_name == 'Basic Plan'){
                        this.max_plan_lookbooks = 10;
                        this.max_plan_lookbook_posts = 50; //unlimited
                    }
                    if(this.sellpoint.business_market_subscription_name == 'Premium Plan'){
                        this.max_plan_lookbooks = 50;//unlimited
                        this.max_plan_lookbook_posts = 50;//unlimited
                        this.can_add_product_lookbook = true; //online shop functionality
                    }
                    
                    
                    let self = this;
                    setTimeout(function(){ self.getGalleryPosts(); }, 3000); //wait for 3sec and call posts in gallery
                    this.preset();
                    this.loading = false;
                }else{
                    this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch((err) => {
                this.loading = false;
                //move
                //maybe no connection ..load from local
               // this.setSellpointLocal(); //removed...caused slower loading
            })
            
        },

        getProductsInBusinessCategories(){
            this.loading = true;
            service.getProductsInBusinessCategories(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) { 
                    this.categories = response.body.data;
                }
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
            })
        },

        getGalleryPosts(){
            this.loading = true;
            service.getPointGalleryPosts(this, this.sellpoint.business_id,0,this.max_plan_lookbooks,0,this.max_plan_lookbook_posts).then(response => {
                // if(response.body.status != 400) {
                    this.galleria = response.body.data;
                    //settings
                    this.total_lookbooks_added = response.body.total_data;

                    if(this.total_lookbooks_added < this.max_plan_lookbooks){
                        this.can_add_more_lookbook = true;
                    }
                //}
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
            })
        },


        getSellpointProducts(){
            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.loading = false;
                }
            }).catch((err) => {})
        },

        getPostsInGallery(gallery){
            this.gallery = gallery;
            this.gallery_post = gallery.gallery_posts_group_posts[0];
            // this.gallery_post_set_image = gallery.gallery_posts_group_posts[0].gallery_post_media;

            //galleryproduct hack
            if(this.gallery.gallery_posts_group_type == 2){
                this.setGalleryPostLocalViewing(this.gallery_post.gallery_post_product_details);
            }
            
            if(this.gallery_post.gallery_post_media[0]){
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            }else{
                this.gallery_post_set_image = {};
            }
            // this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            
            
            this.gallery_view = true;
            //  setTimeout(function(){ 
            //     var top = document.getElementById("galleryview").offsetTop; 
            //     window.scrollTo(0, top); 
            // }, 400);
            // $('#quickviewModal').modal('show');
        },
      
        getCategoryProducts(category){
            this.loading = true;
            this.product = category.business_category_products[0];
            this.products = category.business_category_products;
            $('#quickviewModal').modal('show');
            this.loading = false;
            
        },


        showPost(post){
            
            this.gallery_post = post;
            
            // this.gallery_post_set_image = post.gallery_post_media[0];

            //galleryproduct hack
            if(this.gallery.gallery_posts_group_type == 2){ 
                //DEPRAC--using props--within-component call instead this.setGalleryPostLocalViewing(this.gallery_post.gallery_post_product_details);
                this.componentKey += 1;  
                // $( "#here" ).load(window.location.href + " #here" );
            }
            
            if(this.gallery_post.gallery_post_media[0]){
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            }else{
                this.gallery_post_set_image = {};
            }
            
        },
       
        showPostImage(post_image){
            this.gallery_post_set_image = post_image;
        },
        


        showProduct(product){
            this.product = product;
        },

        //some gallery post config
        setGalleryPostLocalViewing(gallery_product){
            localforage.setItem('galleryproduct', gallery_product).then(function (value) {
                // Do other things once the value has been saved.
               // console.log(value);
            }).catch(function(err) {
                // This code runs if there were any errors
                //console.log(err);
            });
        },
        //
    


       
        resetOptions(){
            this.ordered_product = {};
            this.ordered_product_item = {};
            this.total_price = 0;
            this.place_order = false;
        },

        //mobil-swipe-handle
        handleResize() {
            this.$refs.swipe.reset();
        },

        
    },
   
    destroyed() {
       
    },
    created: function(){
        //do some clearing on localforage
        // localforage.removeItem('galleryproduct');
        localforage.clear(function () {
            // Do other things once the value has been saved.
        //    console.log("done");
        }).catch(function(err) {
            // This code runs if there were any errors
            // console.log(err);
        });

        //continue
        this.setSellpoint();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Home/script.js